module.exports = __webpack_public_path__ + "static/media/integration_instructions_white.12623098.svg";